import { APP_OPTIONS, TOPICAL_PATH } from '../../config/constants';
import { createSearchFacetUrl } from '../../helpers/createSearchUrl';
import type { SearchTopicalContentType } from '../SearchTopical/types';

export default function createTopicalUrl(
  contentType?: SearchTopicalContentType,
  relatedTermType?: string,
  relatedTermName?: string,
) {
  let typeParam: string | undefined;
  const baseUrl = TOPICAL_PATH;

  if (contentType) {
    typeParam = `type=${contentType}`;
  }

  if (relatedTermType && relatedTermName) {
    const facetUrl = createSearchFacetUrl({
      pathname: baseUrl,
      index: APP_OPTIONS.parameters.searchkitIndexTopical,
      facetType: 'refinementList',
      attribute: relatedTermType,
      value: relatedTermName,
    });

    return `${facetUrl}${typeParam ? `&${typeParam}` : ''}`;
  }

  return `${baseUrl}${typeParam ? `?${typeParam}` : ''}`;
}
